export type EngineeringWorkflowStatus = {
	label: string;
	tone: 'neutral' | 'blue' | 'green' | 'red';
};

export type EngineeringRequestType = 'bug' | 'feature' | 'support' | 'system';

export type EngineeringQueueRow = {
	assignee?: string;
	created: string;
	descriptionTail: string;
	priority: 'Highest' | 'High' | 'Medium' | 'Low' | 'Lowest';
	reporter: string;
	requestType: EngineeringRequestType;
	sla: string;
	slaTone: 'breached' | 'paused' | 'running' | 'met';
	status: EngineeringWorkflowStatus;
	summary: string;
};

export const ENGINEERING_WORKFLOW = [
	{ label: 'To do', tone: 'neutral' },
	{ label: 'Triaged', tone: 'blue' },
	{ label: 'In progress', tone: 'blue' },
	{ label: 'Pending on reporter', tone: 'blue' },
	{ label: 'Added to backlog', tone: 'blue' },
	{ label: 'Completed', tone: 'green' },
	{ label: 'Cancelled', tone: 'neutral' },
] as const satisfies readonly EngineeringWorkflowStatus[];

export const ENGINEERING_QUEUE_ROWS: EngineeringQueueRow[] = [
	{
		assignee: 'Issac Varghese',
		created: '24 Jun 2024',
		descriptionTail: 'Happy to provide more details if required.',
		priority: 'Highest',
		reporter: 'Priya Hansra',
		requestType: 'bug',
		sla: 'Today, 11:30 am',
		slaTone: 'breached',
		status: ENGINEERING_WORKFLOW[2],
		summary: 'Save button does nothing on the settings page',
	},
	{
		assignee: 'Issac Varghese',
		created: '24 Jun 2024',
		descriptionTail: 'I need this sorted before the end of the week.',
		priority: 'Medium',
		reporter: 'Robi Lopez',
		requestType: 'feature',
		sla: 'Today, 11:30 pm',
		slaTone: 'running',
		status: ENGINEERING_WORKFLOW[4],
		summary: 'Allow exporting the queue to CSV',
	},
	{
		assignee: 'Jordan Ellis',
		created: '03 Jun 2024',
		descriptionTail: 'This is blocking me from getting my work done today.',
		priority: 'Highest',
		reporter: 'Raul Gonzalez',
		requestType: 'system',
		sla: 'Today, 11:30 pm',
		slaTone: 'paused',
		status: ENGINEERING_WORKFLOW[4],
		summary: 'Login page is timing out for multiple users',
	},
	{
		assignee: 'Jordan Ellis',
		created: '24 Jun 2024',
		descriptionTail: 'I need this sorted before the end of the week.',
		priority: 'Lowest',
		reporter: 'Raul Gonzalez',
		requestType: 'feature',
		sla: '25 Jun, 11:30 pm',
		slaTone: 'running',
		status: ENGINEERING_WORKFLOW[2],
		summary: 'Add a dark mode option to the reporting view',
	},
	{
		created: '03 Jun 2024',
		descriptionTail: 'This is blocking me from getting my work done today.',
		priority: 'Medium',
		reporter: 'Robi Lopez',
		requestType: 'support',
		sla: 'Tomorrow, 5:00 pm',
		slaTone: 'running',
		status: ENGINEERING_WORKFLOW[2],
		summary: 'API returns an auth error after the latest release',
	},
	{
		assignee: 'Laila Ali',
		created: '11 Jun 2024',
		descriptionTail: 'This is blocking me from getting my work done today.',
		priority: 'Medium',
		reporter: 'Raul Gonzalez',
		requestType: 'support',
		sla: 'Tomorrow, 5:00 pm',
		slaTone: 'running',
		status: ENGINEERING_WORKFLOW[2],
		summary: 'Need help configuring SSO for the new workspace',
	},
	{
		assignee: 'Laila Ali',
		created: '18 Jun 2024',
		descriptionTail: 'This is blocking me from getting my work done today.',
		priority: 'Medium',
		reporter: 'Robi Lopez',
		requestType: 'support',
		sla: 'Tomorrow, 11:30 am',
		slaTone: 'running',
		status: ENGINEERING_WORKFLOW[1],
		summary: 'API returns an auth error after the latest release',
	},
	{
		assignee: 'Kayla Parajuli',
		created: '01 Jun 2024',
		descriptionTail: 'I need this sorted before the end of the week.',
		priority: 'High',
		reporter: 'Robi Lopez',
		requestType: 'feature',
		sla: 'Today, 4:00 pm',
		slaTone: 'paused',
		status: ENGINEERING_WORKFLOW[3],
		summary: 'Allow exporting the queue to CSV',
	},
	{
		created: '11 Jun 2024',
		descriptionTail: 'I need this sorted before the end of the week.',
		priority: 'Lowest',
		reporter: 'Priya Hansra',
		requestType: 'support',
		sla: 'Today, 11:30 pm',
		slaTone: 'running',
		status: ENGINEERING_WORKFLOW[0],
		summary: 'Integration with the CRM stopped syncing overnight',
	},
];

export const ENGINEERING_REQUEST_TYPE_LABELS: Record<EngineeringRequestType, string> = {
	bug: 'Report a bug',
	feature: 'Suggest a new feature',
	support: 'Technical support',
	system: 'Report a system problem',
};
